export const fetchAllPaginatedItems = async <T>(
  fetchPage: (
    page: number
  ) => Promise<{ data: T[]; pages: number; total: number }>
): Promise<T[]> => {
  const first = await fetchPage(1)
  const items = [...(first.data || [])]
  const pages = first.pages || 1

  for (let page = 2; page <= pages; page += 1) {
    const next = await fetchPage(page)
    items.push(...(next.data || []))
  }

  return items
}

export const paymentStatusTagColor = (
  status: WalletPaymentStatus
): 'green' | 'yellow' | 'red' | 'gray' | 'blue' => {
  if (status === 'payment_approved' || status === 'payment_authorized') {
    return 'green'
  }
  if (status === 'waiting_payment') return 'yellow'
  if (status === 'payment_refused') return 'red'
  if (status === 'payment_refunded') return 'blue'
  return 'gray'
}

export const filterWalletPayments = (
  payments: WalltetPayment[],
  {
    status,
    method,
    startDate,
    endDate
  }: {
    status?: string | null
    method?: string | null
    startDate?: string | null
    endDate?: string | null
  }
) =>
  payments.filter(payment => {
    if (status && payment.status !== status) return false
    if (method && payment.payment_method !== method) return false
    if (startDate && payment.created_at < `${startDate}T00:00:00.000Z`) {
      return false
    }
    if (endDate && payment.created_at > `${endDate}T23:59:59.999Z`) {
      return false
    }
    return true
  })
